  CF.ready(function() {
    // プライバシーポリシーのポップアップ機能
    const form = document.querySelector('form[data-cf-form]');
    const policyButtons = form.querySelectorAll('[data-policy-opener]');
    const body = document.body;

    const openPolicyPopup = (button) => {
      const popupType = button.getAttribute('data-policy-opener');


      // ポップアップ要素を作成
      const overlay = document.createElement('div');
      overlay.className = 'privacy-policy-overlay';
      
      const popup = document.createElement('div');
      popup.className = 'privacy-policy-popup';
      
      const content = document.createElement('div');
      content.className = 'shopify-policy__container notranslate';
      content.innerHTML = `
        <div class="shopify-policy__title page-header__text-wrapper">
          <h2 class="heading h2">
            ${
              popupType === 'privacy-policy' ? `
                Privacy policy
              ` : popupType === 'cookie-policy' ? `
                Cookie policy
              ` : popupType === 'terms-and-condition' ? `
                Terms and conditions
              ` : popupType === 'contact-us' ? `
                Contact us
              ` : `
                Cookie policy
              `
            }
          </h2>
          <button class="privacy-policy-close-button" title="Close">×</button>
        </div>
        <div class="shopify-policy__body notranslate">
          <div class="rte">
            <div class="privacy-policy-txt-box-space-wide">
            ${
              popupType === 'privacy-policy' ? `
                {%- render 'c-password-page-privacy-policy' -%}
              ` : popupType === 'cookie-policy' ? `
                {%- render 'c-password-page-cookie-policy' -%}
              ` : popupType === 'terms-and-condition' ? `
                {%- render 'c-password-page-terms-and-conditions' -%}
              ` : popupType === 'contact-us' ? `
                {%- render 'c-password-page-contact-us' -%}
              ` : ""
            }
            </div>
          </div>
        </div>
      `;
      
      popup.appendChild(content);
      overlay.appendChild(popup);


      // すでに表示済みの場合はリセット
      if(document.querySelector('.privacy-policy-overlay')){
        document.querySelector('.privacy-policy-overlay').remove();
      }

      body.appendChild(overlay);

      if(popup.querySelector('[data-policy-opener]')){
        popup.querySelector('[data-policy-opener]').addEventListener('click', () => {
          openPolicyPopup(popup.querySelector('[data-policy-opener]'));
        });
      }
      
      // スクロール防止
      body.style.overflow = 'hidden';
      
      // 閉じるボタンのイベントリスナー
      const closeButton = document.querySelector('.privacy-policy-close-button');
      closeButton.addEventListener('click', () => {
        body.removeChild(overlay);
        body.style.overflow = '';
      });
      
      // オーバーレイクリックで閉じる
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          body.removeChild(overlay);
          body.style.overflow = '';
        }
      });
    }
    
    policyButtons.forEach(button => {
      button.addEventListener('click', () => {
        openPolicyPopup(button);
      });
    });

    // ブランド選択の表示切り替え
    const brandDropdown = document.querySelector('.c-accordion-container .cf-enum-field__choices legend');

    if(brandDropdown){
      brandDropdown.addEventListener('click', () => {
        if(brandDropdown.classList.contains('is-open')){
          brandDropdown.classList.remove('is-open');
        }else{
          brandDropdown.classList.add('is-open');
        }
      });
    }

    // URLパラメータ"open"でpopupTypeが指定されていた場合、初期表示後にポップアップを表示
    const urlParams = new URLSearchParams(window.location.search);
    const openType = urlParams.get('open');
    const validTypes = ['privacy-policy', 'cookie-policy', 'terms-and-condition', 'contact-us'];
    if (openType && validTypes.includes(openType)) {
      const autoOpenBtn = document.querySelector(`[data-policy-opener="${openType}"]`);
      if (autoOpenBtn) {
        setTimeout(() => {
          autoOpenBtn.click();
        }, 300);
      }
    }
  });